import type {ReactElement} from 'react';
import {ColorFill} from '@Components/color-fill';
import {AddColorButton} from '@Components/color-picker-v2/components/add-color-button';
import styles from './swatches.module.scss';
import {hexToRgba} from '@Utils/color.util';
import {DEFAULT_SWATCH_SIZE, ROUND_SWATCH_HEIGHT, ROUND_SWATCH_RADIUS, ROUND_SWATCH_WIDTH, SCROLL_PEEK_ROW_ATTRIBUTE, SwatchesLayout} from './swatches.types';
import type {SwatchesProps} from './swatches.types';

export function Swatches({
  className = '',
  hasCustomMargins = false,
  showAddButton = false,
  onClickAdd = (): void => {},
  layout = SwatchesLayout.WRAP,
  ...props
}: SwatchesProps): ReactElement<any> | null {
  const isRoundGrid = layout === SwatchesLayout.ROUND_GRID;
  const isRoundWrap = layout === SwatchesLayout.ROUND_WRAP;

  const getSwatchBorderRadius = (): string | number | undefined => {
    if (isRoundGrid) {
      return ROUND_SWATCH_RADIUS;
    }
    return isRoundWrap ? DEFAULT_SWATCH_SIZE / 2 : undefined;
  };

  const prepareColorSwatches = (): ReactElement<any>[] => {
    return props.colors.map((color, index) => {
      return (
        <ColorFill
          key={`${index}-${color}`}
          onClick={(): void => {
            props.onClick(color);
          }}
          className={isRoundGrid ? styles.roundSwatch : ''}
          width={isRoundGrid ? ROUND_SWATCH_WIDTH : DEFAULT_SWATCH_SIZE}
          height={isRoundGrid ? ROUND_SWATCH_HEIGHT : DEFAULT_SWATCH_SIZE}
          borderRadius={getSwatchBorderRadius()}
          color={hexToRgba(color)}
        />
      );
    });
  };

  const getPeekRowAttributes = (): Record<string, string> => {
    return isRoundGrid ? {[SCROLL_PEEK_ROW_ATTRIBUTE]: ''} : {};
  };

  const getAddButton = (): ReactElement<any> => {
    return <AddColorButton onAddColor={onClickAdd} />;
  };

  return (
    <div
      {...getPeekRowAttributes()}
      className={`${className} ${!hasCustomMargins ? 'spacing-m-t-4 spacing-m-b-3' : ''} ${isRoundGrid ? styles.roundSwatchGrid : `flex-h-row ${styles.container}`}`}
    >
      {showAddButton ? getAddButton() : null}
      {prepareColorSwatches()}
    </div>
  );
}
